import { useAtom, useAtomValue } from 'jotai';

import { Drawer } from '@cfa/react-core';

import { conversationHistoryAtom, historyDrawerOpenAtom } from '../../state';

import HistoryItem from './components/HistoryItem';
import { pinnedConversationsAtom } from './state';

const HistoryDrawer: React.FC = () => {
  const [open, setOpen] = useAtom(historyDrawerOpenAtom);

  const history = useAtomValue(conversationHistoryAtom);
  const pinnedConversations = useAtomValue(pinnedConversationsAtom);

  const sortedHistory = [
    ...pinnedConversations
      .sort((a, b) => a.order - b.order)
      .map(pinnedConversation =>
        history.find(
          conversation => conversation.id === pinnedConversation.conversationId,
        ),
      ),
    ...history.filter(
      conversation =>
        !pinnedConversations.some(
          pinnedConversation =>
            pinnedConversation.conversationId === conversation.id,
        ),
    ),
  ].filter(conversation => conversation !== undefined);

  return (
    <Drawer.Root isOpen={open} onOpenChange={setOpen}>
      <Drawer.Tray isDismissable className="rounded-l-2xl! p-2!">
        <div className="mt-2 flex flex-col px-3">
          <h2 className="text-variant-body2 mb-2 font-bold">Recents</h2>
          {sortedHistory.map(conversation => (
            <HistoryItem key={conversation.id} conversation={conversation} />
          ))}
        </div>
      </Drawer.Tray>
    </Drawer.Root>
  );
};

export default HistoryDrawer;
